import request from '@/utils/request'

export function getWinData() {
  return request({
    url: 'api/v1/tetris-win/conf',
    method: 'post'
  })
}

export function updateWinData(data) {
  return request({
    url: 'api/v1/tetris-win/update',
    method: 'post',
    data: data
  })
}
